import {DataTableColumn} from "mantine-datatable";
import {Button, Group} from '@mantine/core';
import {Meter} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {activate} from '../services/MetersService.ts';
import {useQueryClient} from '@tanstack/react-query';

export const useTableColumns = () => {
    const queryClient = useQueryClient();

    // FNP-665: activate a DRAFT meter via the narrow activateMeter mutation (NOT
    // updateMeter, which silently no-ops for catalog/deploy-hook-created meters).
    // Activation is the deliberate step that lets FNP-589 provision the Stripe meter.
    const handleActivate = async (id: string) => {
        await activate(id);
        queryClient.invalidateQueries({queryKey: ['meters']});
    };

    const columns: DataTableColumn<Meter>[] = [
        {
            accessor: 'name',
            title: I18n.get('Meter'),
            width: '1fr',
        },
        {
            accessor: 'meterCode',
            title: I18n.get('Code'),
            width: '1fr',
            render: (item: Meter) => item.meterCode,
        },
        {
            accessor: 'aggregation',
            title: I18n.get('Aggregation'),
            width: '1fr',
            render: (item: Meter) => item.aggregation,
        },
        {
            accessor: 'grain',
            title: I18n.get('Grain'),
            width: '1fr',
            render: (item: Meter) => item.grain,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: Meter) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'dimensions',
            title: I18n.get('Dimensions'),
            width: '1fr',
            render: (item: Meter) => item.dimensions ? item.dimensions.length : '-',
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            render: (item: Meter) => formatTimestamp(item.created as string),
        },
        {
            accessor: 'actions',
            title: I18n.get('Actions'),
            width: '1fr',
            // FNP-665: an Activate button on DRAFT meters (mirrors the customer-subscriptions
            // activate pattern). Only DRAFT meters show it; activation triggers FNP-589 to
            // mint the Stripe meter on its next reconcile pass.
            render: (item: Meter) => (
                <Group gap="xs">
                    {item.status === 'DRAFT' && (
                        <Button size="xs" onClick={() => handleActivate(item.id)}>
                            {I18n.get('Activate')}
                        </Button>
                    )}
                </Group>
            ),
        },

    ];

    return {
        columns,
    }
}
